import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar el miedo",
    opening: localizedGenderNode(
      [
      "Hoy no peleo con el miedo al fracaso.",
      "Solo noto: esta aquí."
    ],
      [
      "Hoy no peleo con el miedo al fracaso.",
      "Solo noto: esta aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando es más fuerte este miedo?",
      "Que escenario aparece enseguida?",
      "Que siento en mi cuerpo?"
    ],
      [
      "Cuando es más fuerte este miedo?",
      "Que escenario aparece enseguida?",
      "Que siento en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo es una experiencia, no un hecho."
    ],
      [
      "El miedo es una experiencia, no un hecho."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + \"Veo el miedo\".",
      "una respiracion + \"Veo el miedo\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que el miedo empieza.",
      "Solo noto."
    ],
      [
      "Hoy noto el momento en que el miedo empieza.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa justo antes de que suba?",
      "Donde estoy cuando empieza?",
      "Que temo que pase?"
    ],
      [
      "Que pasa justo antes de que suba?",
      "Donde estoy cuando empieza?",
      "Que temo que pase?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un poco de espacio."
    ],
      [
      "En el primer momento tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion cuando empieza el miedo.",
      "una respiracion cuando empieza el miedo."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ],
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde se sienta la tension en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ],
      [
      "Donde se sienta la tension en mi cuerpo?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta protegerme."
    ],
      [
      "Mi cuerpo intenta protegerme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiracion.",
      "una mano en el pecho y una respiracion."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ],
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es el hecho desnudo aquí?",
      "Que historia salto?",
      "Que posibilidad más suave podria ser cierta?"
    ],
      [
      "Cual es el hecho desnudo aquí?",
      "Que historia salto?",
      "Que posibilidad más suave podria ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo debajo",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo debajo del fracaso.",
      "Me quedo con el un momento."
    ],
      [
      "Hoy toco el miedo debajo del fracaso.",
      "Me quedo con el un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "De que tengo miedo que pase?",
      "Que duele más en ese pensamiento?",
      "Que necesitaba escuchar ahora?"
    ],
      [
      "De que tengo miedo que pase?",
      "Que duele más en ese pensamiento?",
      "Que necesitaba escuchar ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo quiere proteccion, no pelea."
    ],
      [
      "El miedo quiere proteccion, no pelea."
    ]
    ),
    action: localizedGenderNode(
      "nombrar el miedo en silencio.",
      "nombrar el miedo en silencio."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "La voz interna",
    opening: localizedGenderNode(
      [
      "Hoy escucho la voz que me advierte.",
      "Sin pelear con ella."
    ],
      [
      "Hoy escucho la voz que me advierte.",
      "Sin pelear con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi voz interna.",
      "Una respiracion."
    ],
      [
      "Noto mi voz interna.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como suena esa voz?",
      "Que intenta proteger?",
      "Que me gustaria decirle?"
    ],
      [
      "Como suena esa voz?",
      "Que intenta proteger?",
      "Que me gustaria decirle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz es solo una voz."
    ],
      [
      "Una voz es solo una voz."
    ]
    ),
    action: localizedGenderNode(
      "notarla sin creerla.",
      "notarla sin creerla."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "La necesidad de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad de seguridad debajo del miedo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco la necesidad de seguridad debajo del miedo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito para sentirme seguro/a?",
      "Que puede ayudarme a seguir a pesar del miedo?",
      "Que me gustaria darme ahora?"
    ],
      [
      "Que necesito para sentirme seguro/a?",
      "Que puede ayudarme a seguir a pesar del miedo?",
      "Que me gustaria darme ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un poco de seguridad cambia el tono."
    ],
      [
      "Un poco de seguridad cambia el tono."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra de seguridad.",
      "escribir una palabra de seguridad."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Soltarlo un momento",
    opening: localizedGenderNode(
      [
      "Hoy veo como se siente soltar el miedo por un momento.",
      "Solo un momento."
    ],
      [
      "Hoy veo como se siente soltar el miedo por un momento.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Dejo que mi cuerpo se ablande un poco.",
      "Una respiracion."
    ],
      [
      "Dejo que mi cuerpo se ablande un poco.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa en mi cuando lo suelto un momento?",
      "Que me asusta de soltarlo?",
      "Que me calma aunque sea un poco?"
    ],
      [
      "Que pasa en mi cuando lo suelto un momento?",
      "Que me asusta de soltarlo?",
      "Que me calma aunque sea un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Soltarlo un momento tambien es elegir."
    ],
      [
      "Soltarlo un momento tambien es elegir."
    ]
    ),
    action: localizedGenderNode(
      "un momento sin pelear con el miedo.",
      "un momento sin pelear con el miedo."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Un lenguaje interno suave",
    opening: localizedGenderNode(
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ],
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ],
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como me hablo cuando temo el fracaso?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ],
      [
      "Como me hablo cuando temo el fracaso?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz suave baja la presion."
    ],
      [
      "Una voz suave baja la presion."
    ]
    ),
    action: localizedGenderNode(
      "decir la frase suave una vez.",
      "decir la frase suave una vez."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Un momento antes de rendirme",
    opening: localizedGenderNode(
      [
      "Hoy pauso un momento antes de rendirme.",
      "Solo un momento."
    ],
      [
      "Hoy pauso un momento antes de rendirme.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de rendirme.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de rendirme.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "De que intento evitar?",
      "Que pasa si sigo un poco?",
      "Que puede sostenerme un momento?"
    ],
      [
      "De que intento evitar?",
      "Que pasa si sigo un poco?",
      "Que puede sostenerme un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño momento cambia la direccion."
    ],
      [
      "Un pequeño momento cambia la direccion."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion antes de rendirme.",
      "una respiracion antes de rendirme."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Volver al presente",
    opening: localizedGenderNode(
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ],
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ],
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ],
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El presente me da suelo."
    ],
      [
      "El presente me da suelo."
    ]
    ),
    action: localizedGenderNode(
      "sentir mis pies un momento.",
      "sentir mis pies un momento."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Un momento antes de intentar",
    opening: localizedGenderNode(
      [
      "Hoy pauso un momento antes de intentar.",
      "Solo un momento."
    ],
      [
      "Hoy pauso un momento antes de intentar.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de parar.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de parar.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que quiero intentar?",
      "Que me asusta de eso?",
      "Que paso pequeño es posible para mi?"
    ],
      [
      "Que quiero intentar?",
      "Que me asusta de eso?",
      "Que paso pequeño es posible para mi?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño intento es movimiento."
    ],
      [
      "Un pequeño intento es movimiento."
    ]
    ),
    action: localizedGenderNode(
      "formular un pequeño intento.",
      "formular un pequeño intento."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño que me devuelve a mi.",
      "No una revolucion."
    ],
      [
      "Hoy elijo un paso pequeño que me devuelve a mi.",
      "No una revolucion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ],
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que paso pequeño puede ayudarme a intentar?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ],
      [
      "Que paso pequeño puede ayudarme a intentar?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño basta."
    ],
      [
      "Lo pequeño basta."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño.",
      "elegir un paso pequeño."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ],
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ],
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi de este miedo?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ],
      [
      "Que aprendi de este miedo?",
      "Cual es la primera señal de que sube?",
      "Cual es mi frase corta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo un momento antes de responder."
    ],
      [
      "Elijo un momento antes de responder."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + mi frase.",
      "una respiracion + mi frase."
    ),
  },
].map(buildNormalizedDay);

export const fearOfFailureBlueprintEs = buildNormalizedPilotBlueprint({
  id: "fear_of_failure_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "fear_of_failure",
  category: "anxiety",
  journeyName: {
    he: "פחד מכישלון",
    en: "Fear of failure",
    es: "Miedo al fracaso",
  },
  days,
});

export default fearOfFailureBlueprintEs;
